<template>
  <div class="head">
      <div class="main nav">
          <div class="nav_div">峰会</div>
          <div class="nav_div nav_div_active">活动</div>
          <div class="nav_div">新闻</div>
      </div>
  </div>
</template>

<script>
export default {
    props:{},
    components:{},
    data(){
        return{

        }
    },
    created:function(){

    },
    methods:{},

}
</script>

<style scoped>
@media (max-width: 768px) {
   .head .nav_div{
       margin-right: 40px;
   }
}
.head{
    background-color: #2c2c2c;
}
.nav {
    display: flex;
    justify-content: left;
}
.nav_div{
    padding: 25px 0;
    margin-right: 80px;
	
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #999999;
    position: relative;
}
.nav_div_active{
    color: #ffffff;
}
.nav_div_active::after{
    content: '';
    position: absolute;
    bottom: 1px;
    display: block;
	width: 41px;
	height: 5px;
	background-color: #00fefe;
	border-radius: 2px;

}



</style>